export const LATEST_KEYWORDS = "latestKeywords";
export const VIDEO_INFOS = "videoInfos";
